import {HttpServiceBase} from '../../../core/services/http-service-base';

export abstract class ITrackingService extends HttpServiceBase{
    public abstract createTrackingEvent(calledSection: string, calledTimestamp: Date): Promise<void>;
}

